module.exports = __webpack_public_path__ + "static/media/thum4.6f87b766.jpg";